<app-breadcrumb [styleBreadcrumb]="'page-heading'" [title]="'SYSTEM-LOGS'" [breadcrumb]="''" [count]="''"
    icon="fa-server">
</app-breadcrumb>
<div class="content-background">
    <div class="row">
        <div class="col-2">
            <label class="k-form-field">
                <span class="k-text-uppercase dark">
                    {{'AVAILABLE-LOGS' | translate}}
                </span>
            </label>
            <kendo-combobox [(ngModel)]="currentSelectedLog" [data]="logTypes" [textField]="'text'"
                [valueField]="'value'" class="w-100" (valueChange)="selectedLog($event)">
            </kendo-combobox>
        </div>
        <div class="col-2">
            <button [disabled]="!currentSelectedLog || loading" kendoButton style="margin-top: 28px;"
                (click)="refresh()">
                {{'GRID-REFRESH' | translate }}<i class="far fa-sync-alt mt-1"></i>
            </button>
        </div>
    </div>
    <div class="mt-3">
        <div *ngIf="loading" class="text-center">
            <span class="k-icon k-i-loading kendo-loading-icon"></span>
        </div>
        <div *ngIf="!loading">
            <div *ngIf="logsData.length === 0">{{'GRID-NO-DATA' | translate}}</div>
            <div #logDiv *ngIf="logsData.length > 0" class="log-container" (resized)="onResized($event)"
                [ngStyle]="{height: logHeight}">
                <div *ngFor="let item of logsData" [innerHTML]="item | safe:'html'"></div>
            </div>
        </div>
    </div>
</div>